'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUploadProgress = exports.getFileId = exports.getLocalId = exports.getFile = undefined;

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _fileUploadKeyPaths = require('../constants/fileUploadKeyPaths');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getFile = exports.getFile = (0, _getIn2.default)(_fileUploadKeyPaths.FILE);

var getLocalId = exports.getLocalId = (0, _getIn2.default)(_fileUploadKeyPaths.LOCAL_ID);

var getFileId = exports.getFileId = (0, _getIn2.default)(_fileUploadKeyPaths.FILE_ID);

var getUploadProgress = exports.getUploadProgress = (0, _getIn2.default)(_fileUploadKeyPaths.UPLOAD_PROGRESS);


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-schema/static-1.4266/js/file-upload/operators/fileUploadGetters.js
// module id = 38
// module chunks = 2 3